import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { useSnackbarNotifications } from '@ts-core/core/hooks/ui';

import {
  getPracticeSessionsQuery,
  GetPracticeSessionsQueryResult,
  GetPracticeSessionsQueryVariables,
} from '../graphql/queries/getPracticeSessionsQuery';
import { PracticeSession } from '../types';

export interface PracticeSessionsHookInput {
  courseId: string;

  notifyError?: boolean;
}

export interface PracticeSessionsHookPayload {
  practiceSessions: PracticeSession[];
  loading: boolean;
  error?: string;
}

export default function usePracticeSessions(input: PracticeSessionsHookInput): PracticeSessionsHookPayload {
  const { courseId, notifyError = true } = input;

  const { showErrorNotification } = useSnackbarNotifications();

  const { data, loading, error } = useQuery<GetPracticeSessionsQueryResult, GetPracticeSessionsQueryVariables>(getPracticeSessionsQuery, {
    variables: { courseId },
    onError: notifyError ? showErrorNotification : undefined,
    fetchPolicy: 'cache-and-network',
  });

  return {
    practiceSessions: data?.practiceSessions || [],
    loading,
    error: getErrorMessage({ error }),
  };
}
